import React, { useState } from 'react';
import { Box, AppBar, Toolbar, Typography, IconButton } from '@mui/material';
import { Menu as MenuIcon, AccountCircle, ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../provider/authProvider';
import AdminSidebar from '../../Components/Admin/admin_sidebar';
import AssignStrategyContent from '../../Components/Admin/AssignStrategyContent';
import './admin_main_page.css';

const AssignStrategyPage = () => {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const navigate = useNavigate();
    const { clearToken } = useAuth();

    const handleSidebarToggle = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const handleLogout = () => {
        clearToken();
        navigate('/login', { replace: true });
    };

    const handleBack = () => {
        navigate('/adminPanel', { state: { activeTab: 'strategy-management' } });
    };

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            minHeight: '100vh'
        }}>
            {/* Sidebar */}
            <AdminSidebar
                activeTab="strategy-management"
                onTabChange={(tab) => {
                    if (tab === 'dashboard') navigate('/adminPanel');
                    else if (tab === 'user-management') navigate('/adminPanel');
                    else if (tab === 'strategy-management') navigate('/adminPanel');
                }}
                onLogout={handleLogout}
            />

            {/* Main Content Area */}
            <Box sx={{
                flex: 1,
                marginLeft: { xs: 0, sm: '240px', md: '280px' },
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column'
            }}>
                {/* Top App Bar */}
                <AppBar
                    position="static"
                    elevation={0}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        background: 'rgba(41, 43, 47, 1)'
                    }}
                >
                    <Toolbar sx={{
                        minHeight: { xs: '48px', sm: '56px' },
                        padding: { xs: '0 8px', sm: '0 16px' }
                    }}>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            onClick={handleSidebarToggle}
                            sx={{
                                display: { xs: 'block', sm: 'none' }
                            }}
                        >
                            <MenuIcon />
                        </IconButton>

                        <Typography
                            variant="h6"
                            component="div"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.25rem' },
                                fontWeight: { xs: 500, sm: 600 },
                                color: 'rgba(255, 255, 255, 0.95)'
                            }}
                        >
                            Assign Pre-Built Strategy
                        </Typography>

                        <Box sx={{ flex: 1 }} />

                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: { xs: 1, sm: 2 }
                        }}>
                            <Typography variant="body2" sx={{
                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                display: { xs: 'none', sm: 'block' },
                                color: 'rgba(255, 255, 255, 0.7)'
                            }}>
                                Admin Panel
                            </Typography>
                            <IconButton sx={{
                                padding: { xs: '4px', sm: '8px' },
                                color: 'rgba(255, 255, 255, 0.9)'
                            }}>
                                <AccountCircle sx={{
                                    fontSize: { xs: '1.25rem', sm: '1.5rem' }
                                }} />
                            </IconButton>
                        </Box>
                    </Toolbar>
                </AppBar>

                {/* Page Content */}
                <Box sx={{
                    flex: 1,
                    padding: { xs: '8px', sm: '16px', md: '24px' },
                    overflow: 'auto',
                    background: '#000000'
                }}>
                    <AssignStrategyContent onBack={handleBack} />
                </Box>
            </Box>
        </Box>
    );
};

export default AssignStrategyPage;
